import { defineActionConstants } from "../../utils/defineActionConstants";
import { START, SUCCESS, ERROR, SET } from "../actionsSubLevels";

export const REQUEST = defineActionConstants("REQUEST", [
  START,
  SUCCESS,
  ERROR
]);
export const COLLAPSE_CONTENT = "COLLAPSE_CONTENT";
export const BREADCRUMBS = defineActionConstants("BREADCRUMBS", [SET]);
export const SET_LANGUAGE = "SET_LANGUAGE";

export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
